import { CoreService } from '@common/services/core.service';
import { Component, EventEmitter, inject, Output, ChangeDetectionStrategy, type OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { IOfficeSelect } from '@app/common/interfaces/domain/office.interface';
import { OfficesService } from '@common/services/office.service';
import { FormsModule } from '@angular/forms';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ProfileService } from '@modules/profile/services/profile.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { PermissionValidatorService } from '@common/services/permission-validator.service';

@Component({
  selector: 'app-office-selector',
  imports: [
    FormsModule,
    SelectModule,
    IftaLabelModule
  ],
  templateUrl: './office-selector.component.html',
  styleUrl: './office-selector.component.scss',
})
export class OfficeSelectorComponent implements OnInit {

  @Output() onOfficeSelectedChange: EventEmitter<IOfficeSelect> = new EventEmitter<IOfficeSelect>();
  private officeService: OfficesService = inject(OfficesService);
  private profileService: ProfileService = inject(ProfileService);
  private coreService: CoreService = inject(CoreService);
  private subscription: Subscription = new Subscription();
  private permissionValidatorService: PermissionValidatorService = inject(PermissionValidatorService);

  officesList: IOfficeSelect[] = [];
  _officeSelected:BehaviorSubject<IOfficeSelect> = new BehaviorSubject<IOfficeSelect>({} as IOfficeSelect);

  loading: boolean = true;

  ngOnInit(): void {
    let officesRequest = null;

    if(this.profileService.isRoot || this.permissionValidatorService.validateRolePermission('offices:management')){
      officesRequest = this.officeService.getAllOfficesForSelector();
    }else{
      officesRequest = this.profileService.getOfficesByProfile();
    }

    officesRequest
    .subscribe({
      next: (offices: IOfficeSelect[]) => {

        // if(this.profileService.isRoot){
        //   offices.unshift({ id: '*', name: 'Todas' });
        //   officeSelected = '*';
        // } else {
        //   officeSelected = offices[0].id;
        // }
        this.officesList = offices;

        const officeSelectedId = this.coreService.getOfficeSelected;

        if(officeSelectedId){
          const officeSelected = offices.find((office: IOfficeSelect) => office.id === officeSelectedId);
          this._officeSelected.next(officeSelected!);
        } else {
          this._officeSelected.next(offices[0]);
        }

        this.officesList = offices;
        
        this.subscription = this._officeSelected
        .subscribe({
          next: (officeSelected: IOfficeSelect) => {
            this.onOfficeSelectedChange.emit(officeSelected);
            this.coreService.setOfficeSelected(officeSelected);
          }
        });
      },
      error: (error: any) => {
        console.error(error);
      }
    })
    .add(() => {
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get officeSelected(): IOfficeSelect {
    return this._officeSelected.getValue();
  }

  set officeSelected(office: IOfficeSelect) {
    this._officeSelected.next(office);
  }

}
